import React from 'react';
import { PrivateRoute } from '../components/PrivateRoute';
import { VehicleRegistration } from '../modules/VehicleRegistration';

const vehicleRegistrationPage = ({ ...props }) => {
  return <PrivateRoute location={props.location.pathname} component={VehicleRegistration} />;
};

export default vehicleRegistrationPage;
